import { NotificationSortType } from '@/app/(routes)/my/notifications/page'
import { queryFactory } from '@/query-factory'
import { useQuery } from '@tanstack/react-query'

export const useNotifications = ({
  queryParams,
}: {
  queryParams?: { sort?: NotificationSortType; isPurchaseTiming?: boolean }
}) => {
  return useQuery({
    ...queryFactory.notification.getNotifications({ queryParams }),
    throwOnError: false,
  })
}
